/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import * as _ from 'lodash';
import { SelectItem } from 'primeng/api/selectitem';
import { Tab } from '../../../core/model/tab.model';
import { AppUtilityService } from '../../../core/services/app-utility.service';


@Component({
  selector: 'lms-query-view-filter-locomotives',
  templateUrl: './query-view-filter-locomotives.component.html',
  styleUrls: ['./query-view-filter-locomotives.component.scss']
})
export class QueryViewFilterLocomotivesComponent implements OnInit, OnChanges {
  @Input() group: any;
  @Input() tab: Tab;
  @Input() tabIndex: number;
  locoForm: UntypedFormGroup;
  selectItem: SelectItem = { label: '--Select--', value: '' };
  @Input() commonopsPicklist;
  permTagList: Array<SelectItem>;
  locoTagList: Array<SelectItem>;
  classCodeList: Array<SelectItem>;
  incidentList: Array<SelectItem>;
  yardLocalList: Array<SelectItem>;
  @Input() yardLocalSelectedList: Array<SelectItem>;
  locoFeaturesListFirst: Array<SelectItem>;
  @Input() locoFeaturesListSecond: Array<SelectItem>;
  @Input() locoFeaturesListThird: Array<SelectItem>;
  tonnageList: Array<SelectItem>;
  dueDayAirFlowList = [
    {
      label: '--Select--',
      value: ''
    },
    {
      label: 'Q Due',
      value: 'qDue'
    },
    {
      label: 'Dead Date',
      value: 'deadDate'
    },
    {
      label: 'Service Due',
      value: 'serviceDue'
    },
    {
      label: '33-Day',
      value: '33Day'
    },
    {
      label: 'Air Flow',
      value: 'airFlow'
    }];
  selectedCity: string;
  selectedValues: string[] = [];
  resetForm = false;

  constructor(private appUtilityService: AppUtilityService) {
    this.permTagList = [];
    this.locoTagList = [];
    this.classCodeList = [];
    this.incidentList = [];
    this.yardLocalList = [];
    this.locoFeaturesListFirst = [];
    this.tonnageList = [];
  }

  /**
   * @param {any} inputName
   * @memberof QueryViewFilterLocomotivesComponent
   */
  checkRespectiveInput(inputName) {
    if (this.locoForm.controls[inputName].value) {
      this[inputName + 'Disable'] = false;
    } else {
      this[inputName + 'Disable'] = true;

    }
  }

  /**
   * @param {any} radioTypeName
   * @memberof QueryViewFilterLocomotivesComponent
   */
  resetDueDayAirFlowRadio(radioTypeName) {
    if (radioTypeName != 'withinDays') {
      this.locoForm.controls.withinDaysRadio.setValue('');
    }
    if (radioTypeName != 'allPastDue') {
      this.locoForm.controls.allPastDue.setValue('');
    }
    if (radioTypeName != 'days') {
      this.locoForm.controls.daysRadio.setValue('');
    }
    setTimeout(() => {
      this.setControl(radioTypeName, !!this.locoForm.controls[radioTypeName]);
    }, 200);
  }

  /**
   * @param {*} name
   * @param {boolean} Isenable
   * @memberof QueryViewFilterLocomotivesComponent
   */
  setControl(name: any, Isenable: boolean): void {
    const ctrl = this.locoForm.controls[name];
    Isenable ? ctrl.enable() : ctrl.disable();
  }

  /** this is angular life cycle this method init when template load
   * @memberof QueryViewFilterLocomotivesComponent
   */
  ngOnInit() {
    // Subscribe to changes
  this.locoForm.get('dueDayAirFlowValue')!.valueChanges.subscribe(value => {
    this.toggleDueDayAirFlowControls(value);
  });

  // Set initial state
  const initialValue = this.locoForm.get('dueDayAirFlowValue')!.value;
  this.toggleDueDayAirFlowControls(initialValue);
    if (this.commonopsPicklist && this.commonopsPicklist.masterData) {
      this.fillPermTagList();
      this.fillLocoTagList();
      this.fillclassCodeList();
      this.fillincidentList();
      this.fillFeatureList();
      this.fillYardLocalList();
      this.fillTonnageCategoryList();
    }
  }

  private toggleDueDayAirFlowControls(value: any) {
  if (!value) {
    this.locoForm.get('withinDaysRadio')!.disable({ emitEvent: false });
    this.locoForm.get('allPastDue')!.disable({ emitEvent: false });
    this.locoForm.get('daysRadio')!.disable({ emitEvent: false });
  } else {
    this.locoForm.get('withinDaysRadio')!.enable({ emitEvent: false });
    this.locoForm.get('allPastDue')!.enable({ emitEvent: false });
    this.locoForm.get('daysRadio')!.enable({ emitEvent: false });
  }
}

  /**
   * every time when input changes and before nginit it fire
   * @memberof QueryViewFilterLocomotivesComponent
   */
  ngOnChanges() {
    this.locoForm = this.group;
    if (this.tab && this.tab.queryView) {
      this.resetForm = this.tab.queryView.resetForm;
      if (this.tab.queryView.resetForm) {
        this.tab.queryView.yardLocalSelected = '';
        this.tab.queryView.features2 = '';
        this.tab.queryView.features3 = '';
      }
      this.fillFeatureList();
      this.fillYardLocalList();

    }
  }

  /**
   * this method fill perm tag dropdown list
   * @memberof QueryViewFilterLocomotivesComponent
   */
  fillPermTagList() {
    const permTagList = this.commonopsPicklist.masterData.permTagList;
    this.permTagList.push(this.selectItem);
    for (let i = 0; i < permTagList.length; i++) {
      this.permTagList.push({
        label: permTagList[i].permTagDisplay,
        value: permTagList[i].permTagValue
      });
    }
    this.locoForm.controls['permTag'].setValue(this.tab.queryView.permTag ? this.tab.queryView.permTag : (this.permTagList.length ? this.permTagList[0].value : ''));
  }


  /**
   * this method fill loco tag dropdown list
   * @memberof QueryViewFilterLocomotivesComponent
   */
  fillLocoTagList() {

    const locoTagList = this.commonopsPicklist.masterData.locoTagList;
    this.locoTagList.push(this.selectItem);
    for (let i = 0; i < locoTagList.length; i++) {
      this.locoTagList.push({
        label: locoTagList[i].locoTagDisplay,
        value: locoTagList[i].locoTagValue
      });
    }

    this.locoForm.controls['locoTag'].setValue(this.tab.queryView.locoTag ? this.tab.queryView.locoTag : (this.locoTagList.length ? this.locoTagList[0].value : ''));

  }

  /**
   * this method fill class code dropdown list
   * @memberof QueryViewFilterLocomotivesComponent
   */
  fillclassCodeList() {
    const classCodeList = this.commonopsPicklist.masterData.classCodeList;
    this.classCodeList.push(this.selectItem);
    for (let i = 0; i < classCodeList.length; i++) {
      this.classCodeList.push({
        label: classCodeList[i],
        value: classCodeList[i]
      });
    }
    this.locoForm.controls['classCode'].setValue(this.tab.queryView.classCode ? this.tab.queryView.classCode : (this.classCodeList.length ? this.classCodeList[0].value : ''));

  }

  /**
   * this method fill incident dropdown list
   * @memberof QueryViewFilterLocomotivesComponent
   */
  fillincidentList() {
    const incidentList = this.commonopsPicklist.masterData.incidentList;
    this.incidentList.push(this.selectItem);

    for (let i = 0; i < incidentList.length; i++) {
      this.incidentList.push({
        label: incidentList[i],
        value: incidentList[i]
      });
    }
    this.locoForm.controls['incidentCode'].setValue(this.tab.queryView.incidentCode ? this.tab.queryView.incidentCode : (this.incidentList.length ? this.incidentList[0].value : ''));

  }


  /**
   *  this method fill YardL ocal dropdown list
   * @memberof QueryViewFilterLocomotivesComponent
   */
  fillYardLocalList() {
    if (this.commonopsPicklist && this.commonopsPicklist.masterData && this.commonopsPicklist.masterData.divisonList) {
      const yardLocalList = this.commonopsPicklist.allocationZoneList;
      this.yardLocalList = [];
      this.yardLocalList.push(this.selectItem);
      for (let i = 0; i < yardLocalList.length; i++) {
        this.yardLocalList.push({
          label: yardLocalList[i].oprZoneCode + ' ' + yardLocalList[i].oprZoneName,
          value: yardLocalList[i].oprZoneCode
        });
      }
      this.yardLocalList.push({
        label: 'Unallocated',
        value: 'unallocated'
      });
      this.locoForm.controls['yardLocal'].setValue((!this.resetForm && this.tab.queryView.yardLocal) ? this.tab.queryView.yardLocal : (this.yardLocalList.length ? this.yardLocalList[0].value : ''));
      this.fillYardLocalRespectiveList({ value: (!this.resetForm && this.tab.queryView.yardLocal) ? this.tab.queryView.yardLocal : this.yardLocalList[0].value }, true);
    }
  }

  /**
   *  this method check that feature is include or exclude
   * @param {string} typeName
   * @memberof QueryViewFilterLocomotivesComponent
   */
  toggleExcludeIncludeOnlyState(typeName: string) {
    setTimeout(() => {
      if (typeName === 'offline') {
        if (this.locoForm.controls['offline'].value === 'only') {
          this.locoForm.controls['stored'].setValue('exclude');
        }
      } else {
        if (this.locoForm.controls['stored'].value === 'only') {
          this.locoForm.controls['offline'].setValue('exclude');
        }
      }
    }, 100);
  }

  /**
   *  this method fill Yard Local respective dropdown list
   * @param {any} event
   * @param {boolean} [forminit]
   * @memberof QueryViewFilterLocomotivesComponent
   */
  fillYardLocalRespectiveList(event, forminit?: boolean) {
    let allYardLocalList = this.commonopsPicklist.allocationZoneList.find(obj => obj.oprZoneCode === event.value);
    // const yardLocalListSelected = _.filter(allYardLocalList, function (o) { return o['divisionMnemonic'] === event.value; });
    this.yardLocalSelectedList = [];
    if (event.value) {
      this.yardLocalSelectedList.push({
        label: 'All Stations',
        value: ''
      });
    }
    if (allYardLocalList && allYardLocalList.allocatedStationList) {
     // allYardLocalList = allYardLocalList['allocationStationList'];
      for (let allocationStation of allYardLocalList['allocatedStationList'].sort()) {
        this.yardLocalSelectedList.push({
          label: allocationStation,
          value: allocationStation
        });
      }
    }
    if (forminit) {
      this.locoForm.controls['yardLocalSelected'].setValue(this.tab.queryView.yardLocalSelected ? this.tab.queryView.yardLocalSelected : (this.yardLocalSelectedList.length ? this.yardLocalSelectedList[0].value : ''));
    } else {
      this.locoForm.controls['yardLocalSelected'].setValue(this.yardLocalSelectedList.length ? this.yardLocalSelectedList[0].value : '');
    }
  }

  /**
   *  this method fill tonnage category dropdown list
   * @memberof QueryViewFilterLocomotivesComponent
   */
  fillTonnageCategoryList() {
    const tonnageList = this.commonopsPicklist.masterData.classCategoryList;
    this.tonnageList.push(this.selectItem);
    for (let i = 0; i < tonnageList.length; i++) {
      this.tonnageList.push({
        label: tonnageList[i].classCategory,
        value: tonnageList[i].classValue
      });
    }
    this.locoForm.controls['classCategory'].setValue(this.tab.queryView.classCategory ? this.tab.queryView.classCategory : (this.tonnageList.length ? this.tonnageList[0].value : ''));

  }

  /**
   * this method fill first feature dropdown list
   * @memberof QueryViewFilterLocomotivesComponent
   */
  fillFeatureList() {
    const locoFeaturesList = this.commonopsPicklist.masterData.jweleryFeaturesList;
    this.locoFeaturesListFirst = [];
    this.locoFeaturesListFirst.push(this.selectItem);
    for (let i = 0; i < locoFeaturesList.length; i++) {
      this.locoFeaturesListFirst.push({
        label: locoFeaturesList[i],
        value: locoFeaturesList[i]
      });
    }
    this.locoForm.controls['features1'].setValue(!this.resetForm && this.tab.queryView.features1 ? this.tab.queryView.features1 : (this.locoFeaturesListFirst.length ? this.locoFeaturesListFirst[0].value : ''));
    if (this.tab.queryView.features1) {
      this.fillFeatureListSecond({ value: '' }, true);
    }
  }

  /**
   * this method fill second feature dropdown list
   * when we select first feature
   * @param {boolean} [frominit]
   * @memberof QueryViewFilterLocomotivesComponent
   */
  fillFeatureListSecond(event, frominit?: boolean) {
    const checkValue = this.locoForm.controls['features1'].value;
    this.locoFeaturesListSecond = _.filter(this.locoFeaturesListFirst, function (o) { return (o.value !== checkValue && checkValue !== ''); });
    if (frominit) {
      this.locoForm.controls['features2'].setValue(this.tab.queryView.features2 ? this.tab.queryView.features2 : (this.locoFeaturesListSecond.length ? this.locoFeaturesListSecond[0].value : ''));
      this.fillFeatureListThird({}, frominit);
    } else {
      this.locoForm.controls['features2'].setValue(this.locoFeaturesListSecond.length ? this.locoFeaturesListSecond[0].value : '');
      this.fillFeatureListThird({});
    }
  }

  /**
   * this method fill third feature dropdown list
   * when we select second feature
   * @param {boolean} [frominit]
   * @memberof QueryViewFilterLocomotivesComponent
   */
  fillFeatureListThird(event, frominit?: boolean) {
    const checkValue = this.locoForm.controls['features1'].value;
    const checkValue2 = this.locoForm.controls['features2'].value;
    this.locoFeaturesListThird = _.filter(this.locoFeaturesListFirst, function (o) { return (o.value !== checkValue2 && checkValue !== '' && checkValue2 !== '' && o.value !== checkValue); });
    if (frominit) {
      this.locoForm.controls['features3'].setValue(this.tab.queryView.features3 ? this.tab.queryView.features3 : (this.locoFeaturesListThird.length ? this.locoFeaturesListThird[0].value : ''));
    } else {
      this.locoForm.controls['features3'].setValue(this.locoFeaturesListThird.length ? this.locoFeaturesListThird[0].value : '');
    }

  }
}
